import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Customer, CustomerTrailerSearch, CustomerVehiclePromotions, PromoDetails } from '@pos-app/data';
import { BehaviorSubject, Subject } from 'rxjs';
import { concatMap, debounceTime, distinctUntilChanged, filter, takeUntil, finalize } from 'rxjs/operators';
import { sortCustomerTrailerSearchList } from '../../utils/utils-camper-trailer';
import { ApiService } from '../../services';

@Component({
    selector: 'pos-app-lib-customer-vehicle-search',
    templateUrl: './customer-vehicle-search.component.html',
    styleUrls: ['./customer-vehicle-search.component.scss'],
    standalone: false
})
export class CustomerVehicleSearchComponent implements OnInit, OnDestroy {
  @Output() newCustomerVehiclePromotion = new EventEmitter<CustomerVehiclePromotions>();
  @Output() showResultText = new EventEmitter<boolean>();
  @ViewChild('searchBox') searchBox: ElementRef;
  @ViewChild('searchResult') searchResult!: ElementRef;

  showTable = false;
  unSubscribe$ = new Subject<void>();
  public loading$ = new BehaviorSubject<boolean>(false);
  customerSelected: CustomerTrailerSearch = null;
  listOfCustomerVehiclePromotions: PromoDetails[] = [];

  indexFocus = 0;

  customerVehicleSearchForm: UntypedFormGroup;
  initialSearch: boolean = true;
  listOfCustomerWithSameRego: any;

  constructor(private apiService: ApiService, private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.customerVehicleSearchForm = this.fb.group({
      customerVehicleSearch: [''],
    });

  }

  onSearch() {
    this.initialSearch = false;
    this.loading$.next(true);
    this.apiService
      .fetchVehiclePromotionsByRego({
        rego: this.customerVehicleSearchForm.get('customerVehicleSearch').value,
      })
      .subscribe((res) => {
         this.loading$.next(false);
        if (!res?.SearchResults?.length) {
          this.listOfCustomerVehiclePromotions = [];
          this.newCustomerVehiclePromotion.emit(null);
          this.showResultText.emit(true);
          this.customerVehicleSearchForm.get('customerVehicleSearch').setValue('');
          return;
        } else if (res?.SearchResults?.length === 1) {
          this.newCustomerVehiclePromotion.emit(res?.SearchResults[0]);
          this.customerVehicleSearchForm.get('customerVehicleSearch').setValue('');
          this.initialSearch = true;
        } else {
          this.showTable = true;
          this.listOfCustomerWithSameRego = res?.SearchResults;
          this.indexFocus = 0;
        }
      });
  }

  getCustomersSearchVehicle(parameters: any) {
    return this.apiService.fetchVehiclePromotionsByRego({
      rego: parameters,
    });
  }

  selectCustomer(i) {
    this.showTable = false;
    this.customerVehicleSearchForm.get('customerVehicleSearch').setValue('');
    this.newCustomerVehiclePromotion.emit(this.listOfCustomerWithSameRego[i]);
  }

  lostFocus(e) {
    setTimeout(() => {
      let isMouseOnTable = document.querySelector('.searchResult:hover');
      if (!isMouseOnTable && !this.customerVehicleSearchForm.get('customerVehicleSearch').value) {
        this.showTable = false;
      }
      //this.searchBox.nativeElement.focus();
    }, 300);
  }

  onKeyboard(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      let newIdx = this.indexFocus + (e.key === 'ArrowDown' ? 1 : -1);
      newIdx = newIdx < 0 ? 0 : newIdx;
      this.indexFocus = newIdx % this.listOfCustomerWithSameRego.length;
    } else if (e.key === 'Enter') {
      this.listOfCustomerWithSameRego =[]
      this.onSearch();
    } else {
      //this.showTable = true;
    }
  }

  isFocus(e) {
    //this.showTable = true;
    e.target.select();
  }

  clearSearch() {
    this.customerVehicleSearchForm.get('customerVehicleSearch').setValue('');
    this.showTable = false;
    this.showResultText.emit(false);
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}

